import HelperPlatform from 'utils/helper-platform'
import Input from "theme/Input";
import React, { useCallback, useState } from 'react'
import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationCommuteAddressValidate from 'graphql/mutations/MutationCommuteAddressValidate'
import { Keyboard, StyleSheet, View } from 'react-native'
import _ from 'lodash'
import HStack from 'components/atoms/stack/HStack'
import LoadingComponent from 'components/atoms/Loading'

const FormAddress = ({ field, getFormValue, onChange, filter, ...props }) => {
	
	const [ validating, setValidating ] = useState( false )
	const [ value, setValue ] = useState( String( getFormValue( field.name, '' ) ) )
	
	const onValidate = ( value ) => {
		if( _.size( String( value ) ) < 4 ) {
			return;
		}
		
		new GraphqlBuilder()
			.addQuery( 'address_validate', MutationCommuteAddressValidate, {
				address: value,
			})
			.setOnStart( () => {
				setValidating( true )
			})
			.setOnSuccess( result => {
				const isValid = result?.address_validate?.address_validate?.is_valid === 'yes';
				
				onChange({ value, isValid })
			})
			.setOnFinally( () => {
				setValidating( false )
			})
			.execute();
	}
	
	const onValidateDebounce = useCallback( _.debounce( onValidate, 750 ), [] );
	
	const onChangeText = ( value ) => {
		// Remove all non-numeric characters
		if( filter !== 'none' ) {
			value = value.replace( /[^0-9--]/g, '' );
		}
		
		setValue( value )
		onValidateDebounce( value )
	}
	
	return (
		<HStack
			style={ styles.container }>
			
			<Input
				{ ...props }
				style={[ styles.input, props.style ]}
				keyboardType={ HelperPlatform.isIOS() ? "phone-pad" : "number-pad" }
				defaultValue={ value }
				value={ value }
				blurOnSubmit={ false }
				returnKeyType='done'
				onSubmitEditing={ Keyboard.dismiss }
				maxLength={ props.maxLength ?? 4 }
				onChangeText={ onChangeText }
			/>
			
			<View
				style={ styles.loadingContainer }>
				
				{ validating ? <LoadingComponent size={ 'xs' } /> : null }
			</View>
		</HStack>
	)
}

const styles = StyleSheet.create({
	container: {
		width: '100%',
	},
	input: {
		flex: 1,
	},
	loadingContainer: {
		alignItems: 'center',
		justifyContent: 'center',
	}
})

export default FormAddress
